import React from "react";
import MessengerLayout from "../../layout/MessengerLayout";
import MyDiaryCalendar from "../../components/diary/MyDiaryCalendar";

// Settings › My diary. Owner-only read view over the sealed diary store.
export default function MyDiaryPage() {
  return (
    <MessengerLayout>
      <div style={{ padding: "28px 16px" }}>
        <MyDiaryCalendar />
      </div>
    </MessengerLayout>
  );
}
